<template>
    <div class="part-wrap section-wrap">
        <div class="left">
            <div class="collapse-title" @click="toggle_panel('is_part_show')">款式选择</div>
            <div class="collapse-content" v-show="is_part_show">
                <div class="list" v-for="(item,index) in part" :key="`p`+index" @click="open_right(item, 1)">
                    <div class="item" v-show="item.is_show>0">
                        <span class="name"><span class="red">*</span>{{ item.category_name_cn }}</span>
                        <span class="value">{{part_list[item.category_key]}}</span>
                    </div>
                </div>
            </div>

            <div class="collapse-title" v-show="accessory.length>0"
                 @click="toggle_panel('is_accessory_show')">辅料搭配
            </div>
            <div class="collapse-content" v-show="is_accessory_show">
                <div class="list" v-for="(item,index) in accessory" :key="`d`+index" @click="open_right(item, 3)">
                    <div class="item">
                        <span class="name">{{ item.deep_name }}</span>
                        <span class="value">{{accessory_list[item.deep_key]}}</span>
                    </div>
                </div>
            </div>

            <div class="collapse-title" v-show="flower.length>0"
                 @click="toggle_panel('is_flower_show')">插花眼
            </div>
            <div class="collapse-content" v-show="is_flower_show">
                <div class="list" v-for="(item,index) in flower" :key="`f`+index" @click="open_right(item, 2)">
                    <div class="item">
                        <span class="name">{{ item.deep_name }}</span>
                        <span class="value">{{flower_list[item.deep_key]}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="right">
            <div class="cate-box">
                <template v-if="show_type===1">
                    <div class="cate" v-for="oItem in show_item.option_list"
                         @click="choose_part(show_item.category_key, show_item.category_name_cn, oItem.part_name_cn,oItem.part_key, oItem.model_path, show_item.no_cad)"
                         :class="{'cate-active':part_list[show_item.category_key]==oItem.part_name_cn,'select-active':part_list[show_item.category_key]==oItem.part_name_cn}">
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.part_name_cn }}</div>
                    </div>
                </template>

                <template v-if="show_type===2">
                    <div class="cate" v-for="oItem in show_item.option_list"
                         @click="choose_flower(show_item.deep_key, show_item.deep_name, oItem.text, oItem.key, oItem.sku)"
                         :class="{'cate-active':flower_list[show_item.deep_key]==oItem.text,'select-active':flower_list[show_item.deep_key]==oItem.text}">
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.text }}</div>
                    </div>
                </template>

                <template v-if="show_type===3">
                    <template v-if="show_item.deep_key==='AF'">
                        <div class="radio-wrap">
                            <RadioGroup v-model="filter_accessory[`AF`]">
                                <Radio :label="0"><span>全部</span></Radio>
                                <Radio :label="3"><span>高档</span></Radio>
                                <Radio :label="2"><span>中档</span></Radio>
                                <Radio :label="1"><span>普通</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="cate" v-for="oItem in show_item.option_list"
                             @click="choose_fl_fabric_key(show_item.deep_key, show_item.deep_name,oItem.text,oItem.fabric_key, oItem.material, oItem.color)"
                             :class="{'cate-active':form_data.fl_fabric_key===oItem.fabric_key,'select-active':form_data.fl_fabric_key===oItem.fabric_key}"
                             v-show="filter_accessory[`AF`]==0||oItem.dangci==filter_accessory[`AF`]"
                        >
                            <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                            <img class="img"
                                 v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                            <div class="name"> {{ oItem.text }}</div>
                        </div>
                        <div class="color-list">
                            <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ffcc`+kc" @click="choose_fl_common_color(vc, show_item, `fl`)">
                                <div class="item-wrap">
                                    <img :src="vc.color_value" alt="" class="color-image" />
                                    <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                    <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                </div>
                                <p class="color-name">{{vc.color_name_cn}}</p>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="show_item.deep_key==='AC'">
                        <div class="cate" v-for="oItem in show_item.option_list"
                             @click="choose_fl2_fabric_key(show_item.deep_key, show_item.deep_name,oItem.text,oItem.fabric_key, {...oItem.material, sync_type: oItem.sync_type}, oItem.color)"
                             :class="{'cate-active':form_data.fl2_fabric_key===oItem.fabric_key,'select-active':form_data.fl2_fabric_key===oItem.fabric_key}"
                             v-show="filter_accessory[`AF`]==0||oItem.dangci==filter_accessory[`AF`]"
                        >
                            <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                            <img class="img"
                                 v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                            <div class="name"> {{ oItem.text }}</div>
                        </div>
                        <div class="color-list">
                            <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ffcc`+kc" @click="choose_fl_common_color(vc, show_item, `fl2`)">
                                <div class="item-wrap">
                                    <img :src="vc.color_value" alt="" class="color-image" />
                                    <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                    <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                </div>
                                <p class="color-name">{{vc.color_name_cn}}</p>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="show_item.deep_key==='AD'">
                        <div class="radio-wrap">
                            <RadioGroup v-model="filter_accessory[`AD`]">
                                <Radio :label="0"><span>全部</span></Radio>
                                <Radio :label="3"><span>高档</span></Radio>
                                <Radio :label="2"><span>中档</span></Radio>
                                <Radio :label="1"><span>普通</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="cate" v-for="oItem in show_item.option_list"
                             @click="choose_fl3_fabric_key(show_item.deep_key, show_item.deep_name,oItem.text, oItem.key, oItem.material, oItem.color)"
                             :class="{'cate-active':form_data.fl3_fabric_key===oItem.key,'select-active':form_data.fl3_fabric_key===oItem.key}"
                             v-show="filter_accessory[`AD`]==0||oItem.dangci==filter_accessory[`AD`]"
                        >
                            <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                            <img class="img"
                                 v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                            <div class="name"> {{ oItem.text }}</div>
                        </div>
                        <div class="color-list">
                            <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ffcc`+kc" @click="choose_fl_common_color(vc, show_item, `fl3`)">
                                <div class="item-wrap">
                                    <img :src="vc.color_value" alt="" class="color-image" />
                                    <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                    <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                </div>
                                <p class="color-name">{{vc.color_name_cn}}</p>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="show_item.deep_key==='AE'">
                        <div class="radio-wrap">
                            <RadioGroup v-model="filter_accessory[`AE`]">
                                <Radio :label="0"><span>全部</span></Radio>
                                <Radio :label="3"><span>高档</span></Radio>
                                <Radio :label="2"><span>中档</span></Radio>
                                <Radio :label="1"><span>普通</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="cate" v-for="oItem in show_item.option_list"
                             @click="choose_fl4_fabric_key(show_item.deep_key, show_item.deep_name,oItem.text, oItem.key, oItem.material, oItem.color)"
                             :class="{'cate-active':form_data.fl4_fabric_key===oItem.key,'select-active':form_data.fl4_fabric_key===oItem.key}"
                             v-show="filter_accessory[`AE`]==0||oItem.dangci==filter_accessory[`AE`]"
                        >
                            <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                            <img class="img"
                                 v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                            <div class="name"> {{ oItem.text }}</div>
                        </div>
                        <div class="color-list">
                            <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ffcc`+kc" @click="choose_fl_common_color(vc, show_item, `fl4`)">
                                <div class="item-wrap">
                                    <img :src="vc.color_value" alt="" class="color-image" />
                                    <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                    <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                </div>
                                <p class="color-name">{{vc.color_name_cn}}</p>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="radio-wrap">
                            <RadioGroup v-model="filter_accessory[show_item.deep_key]">
                                <Radio :label="0"><span>全部</span></Radio>
                                <Radio :label="3"><span>高档</span></Radio>
                                <Radio :label="2"><span>中档</span></Radio>
                                <Radio :label="1"><span>普通</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="cate" v-for="oItem in show_item.option_list"
                             @click="choose_accessory(show_item.deep_key, show_item.deep_name, oItem.text, oItem.key)"
                             :class="{'cate-active':accessory_list[show_item.deep_key]==oItem.text,'select-active':accessory_list[show_item.deep_key]==oItem.text}"
                             v-show="filter_accessory[show_item.deep_key]==0||oItem.dangci==filter_accessory[show_item.deep_key]"
                        >
                            <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                            <img class="img"
                                 v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                            <div class="name"> {{ oItem.text }}</div>
                        </div>
                        <div class="color-list">
                            <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ac`+kc" @click="choose_accessory_color(vc, show_item)">
                                <div class="item-wrap">
                                    <img :src="vc.color_value" alt="" class="color-image" />
                                    <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                    <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                </div>
                                <p class="color-name">{{vc.color_name_cn}}</p>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>

    </div>

</template>

<script>
    import {mapState} from 'vuex'
    import {MAccessoryColor} from "@/api";
    export default {
        name: "Part",
        data() {
            return {
                accessory_color_map: {},
                is_part_show: true,
                is_accessory_show: true,
                is_flower_show: true,
                show_type: 1,
                show_item: {},

                filter_accessory: {},
                part_value: [],
                cal_part: [],
                cal_flower: [],
                relate_map_part: new Map(),
                relate_map_accessory: new Map(),
                relate_map_flower: new Map(),
                interval_id: null
            }
        },
        computed: {
            ...mapState({
                category: (state) => state.mtm.picked_category,
                part: (state) => state.mtm.picked_category.hasOwnProperty('part') ? state.mtm.picked_category.part : Array.of(),
                accessory: (state) => state.mtm.picked_category.hasOwnProperty('accessory') ? state.mtm.picked_category.accessory : Array.of(),
                flower: (state) => state.mtm.picked_category.hasOwnProperty('flower') ? state.mtm.picked_category.flower : Array.of(),
                part_list: (state) => state.mtm.form_data.part_list,
                accessory_list: (state) => state.mtm.form_data.accessory_list,
                flower_list: (state) => state.mtm.form_data.flower_list,
                form_data: (state) => state.mtm.form_data,
            }),
            accessory_key2option_map() {
                let obj = {}
                for(let i in this.form_data.accessory_code) {
                    obj[this.form_data.accessory_code[i].deep_key] = this.form_data.accessory_code[i].option_key
                }
                return obj
            },
            accessory_option2color_map() {
                let obj = {}
                for(let i in this.form_data.accessory_code) {
                    if(this.form_data.accessory_code[i].option_key) {
                        obj[this.form_data.accessory_code[i].option_key] = this.form_data.accessory_code[i].color_key
                    }
                }
                return obj
            },
        },
        methods: {
            open_right(item, show_type = 1) {
                this.show_type = show_type
                this.show_item = item
            },
            toggle_panel(key) {
                this.$set(this, key, !!!(this[key]))
            },
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            choose_accessory_color(color_item, current_item) {
                this.$store.commit('mtm/choose_accessory_color', {
                    color_item, deep_key: current_item.deep_key
                })
            },
            choose_accessory(deep_key, deep_name, option_name, option_key) {
                this.$store.commit('mtm/choose_accessory', {
                    deep_key, deep_name, option_name, option_key
                })

                // 修改被影响的选项
                if (this.relate_map_accessory.has(option_name)) {
                    // 每个关联显示的部位
                    for (let key_self in this.relate_map_accessory.get(option_name)) {
                        // 自身配置里能显示的选项
                        let filter_option_list = this.relate_map_accessory.get(option_name)[key_self]
                        // 寻找其他部位选中项可能对当前的影响
                        for (let key_another in this.accessory_list) {
                            let part_another = this.accessory.find(v => v.deep_key === key_another)
                            let relate_another = part_another.option_list.find(v => v.text == this.accessory_list[key_another])
                            // 寻找其他部位选中项是否有relate_part对当前的影响
                            let ldd = {option_list: (relate_another && this.relate_map_accessory.has(relate_another.text) && this.relate_map_accessory.get(relate_another.text)[key_self] ? this.relate_map_accessory.get(relate_another.text)[key_self] : [])}
                            if (ldd.option_list.length === 0) {
                                continue;
                            }
                            let sa = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.text)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            filter_option_list = filter_option_list.filter(v => intersect_keys.includes(v.text))
                            filter_option_list = [...new Map(filter_option_list.map(v => [v.text, v])).values()]
                        }

                        if ((this.accessory.map(v => v.deep_key)).includes(key_self)) {
                            let idx = this.accessory.findIndex((v) => {
                                return v.deep_key === key_self
                            })
                            if (idx === -1) {
                                continue;
                            }

                            // 填充计算后选项
                            this.$store.commit('mtm/update_category_option', {
                                key: 'accessory',
                                index: idx,
                                option_list: filter_option_list
                            })
                            // 统一清除关联项重新选择
                            this.$store.commit('mtm/clear_accessory', {
                                deep_key: key_self
                            })
                        }
                    }
                }
            },
            choose_flower(deep_key, deep_name, option_name, option_key, sku) {
                this.$store.commit('mtm/choose_flower', {
                    deep_key, deep_name, option_name, option_key, sku
                })

                // 修改被影响的选项
                if (this.relate_map_flower.has(option_name)) {
                    // 每个关联显示的部位
                    for (let key_self in this.relate_map_flower.get(option_name)) {
                        // 自身配置里能显示的选项
                        let filter_option_list = this.relate_map_flower.get(option_name)[key_self]
                        // 寻找其他部位选中项可能对当前的影响
                        for (let key_another in this.flower_list) {
                            let part_another = this.flower.find(v => v.deep_key === key_another)
                            let relate_another = part_another.option_list.find(v => v.text == this.flower_list[key_another])
                            // 寻找其他部位选中项是否有relate_part对当前的影响
                            let ldd = {option_list: (relate_another && this.relate_map_flower.has(relate_another.text) && this.relate_map_flower.get(relate_another.text)[key_self] ? this.relate_map_flower.get(relate_another.text)[key_self] : [])}
                            if (ldd.option_list.length === 0) {
                                continue;
                            }
                            let sa = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.text)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            filter_option_list = filter_option_list.filter(v => intersect_keys.includes(v.text))
                            filter_option_list = [...new Map(filter_option_list.map(v => [v.text, v])).values()]
                        }

                        if ((this.flower.map(v => v.deep_key)).includes(key_self)) {
                            let idx = this.flower.findIndex((v) => {
                                return v.deep_key === key_self
                            })
                            if (idx === -1) {
                                continue;
                            }

                            // 填充计算后选项
                            this.$store.commit('mtm/update_category_option', {
                                key: 'flower',
                                index: idx,
                                option_list: filter_option_list
                            })
                            // 统一清除关联项重新选择
                            this.$store.commit('mtm/clear_flower', {
                                deep_key: key_self
                            })
                        }
                    }
                }
            },
            choose_part(part_key, part_name, option_name, option_key, model_path, no_cad) {
                this.$store.commit('mtm/choose_part', {
                    part_key, part_name, option_name, option_key, model_path, no_cad
                })
                // 修改被影响的选项
                if (this.relate_map_part.has(option_key)) {
                    // 每个关联显示的部位
                    for (let key_self in this.relate_map_part.get(option_key)) {
                        // 自身配置里能显示的选项
                        let filter_option_list = this.relate_map_part.get(option_key)[key_self]
                        // 寻找其他部位选中项可能对当前的影响
                        for (let key_another in this.part_list) {
                            let part_another = this.part.find(v => v.category_key === key_another)
                            let relate_another = part_another.option_list.find(v => v.part_name_cn == this.part_list[key_another])
                            // let ldd = relate_another && relate_another.hasOwnProperty('relate_part') && relate_another.relate_part.find(v=>v.category_key == key_self)? relate_another.relate_part.find(v=>v.category_key == key_self) : {option_list: []}
                            // FE U G GF Q
                            let ldd = {option_list: (relate_another && this.relate_map_part.has(relate_another.part_key) && this.relate_map_part.get(relate_another.part_key)[key_self] ? this.relate_map_part.get(relate_another.part_key)[key_self] : [])}
                            if (ldd.option_list.length === 0) {
                                continue;
                            }
                            let sa = Array.from(new Set(filter_option_list.map(v => v.part_key)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.part_key)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            filter_option_list = filter_option_list.filter(v => intersect_keys.includes(v.part_key))
                            filter_option_list = [...new Map(filter_option_list.map(v => [v.part_key, v])).values()]
                        }

                        if ((this.part.map(v => v.category_key)).includes(key_self)) {
                            let idx = this.part.findIndex((v) => {
                                return v.category_key === key_self
                            })
                            if (idx === -1) {
                                continue;
                            }

                            // 填充计算后选项
                            this.$store.commit('mtm/update_category_option', {
                                key: 'part',
                                index: idx,
                                option_list: filter_option_list
                            })
                            let key_self_item = this.part.find(v => v.category_key === key_self)
                            let first_option = filter_option_list[0]
                            // console.log(111, key_self, key_self_item, first_option)
                            if (first_option) {
                                this.choose_part(key_self, key_self_item.category_name_cn, first_option.part_name_cn, first_option.part_key, first_option.model_path, key_self_item.no_cad)
                            }
                            // 统一清除关联项重新选择
                            // this.$store.commit('mtm/clear_part', {part_key: key_self})
                        }

                        if ((this.flower.map(v => v.deep_key)).includes(key_self)) {
                            let idx = this.flower.findIndex((v) => {
                                return v.deep_key === key_self
                            })
                            if (idx === -1) {
                                continue;
                            }

                            filter_option_list = filter_option_list.map(v => {
                                return {text: v.part_name_cn, image: v.image, key: v.part_key}
                            })
                            // 填充计算后选项
                            this.$store.commit('mtm/update_category_option', {
                                key: 'flower',
                                index: idx,
                                option_list: filter_option_list
                            })
                            // 统一清除关联项重新选择
                            this.$store.commit('mtm/clear_flower', {
                                deep_key: key_self
                            })
                        }

                        // if(filter_option_list.length > 0) {
                        //     let allow_option_name = filter_option_list.map(v=>v.part_name_cn)
                        //     // 选项溢出需重新选择第一项
                        //     if(!allow_option_name.includes(this.part_list[key_self])) {
                        //         let new_part = this.part.find(v => v.category_key === key_self)
                        //         let new_option = new_part.option_list[0]
                        //         this.$store.commit('mtm/choose_part', {
                        //             part_key: new_part.category_key, part_name:new_part.category_name_cn, option_name:new_option.part_name_cn, option_key:new_option.part_key, model_path:"", no_cad:new_part.no_cad
                        //         })
                        //     }
                        // }
                    }
                }
            },
            choose_fl_common_color(color_item, item, prefix) {
                this.$store.commit('mtm/choose_fl_common_color', {
                    deep_key: item.deep_key, prefix, color_item
                })
            },
            choose_fl_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_accessory(deep_key, deep_name, option_name, fabric_key)
                this.$store.commit('mtm/choose_fl_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
            choose_fl2_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_accessory(deep_key, deep_name, option_name, fabric_key)
                this.$store.commit('mtm/choose_fl2_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
            choose_fl3_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_accessory(deep_key, deep_name, option_name, fabric_key)
                this.$store.commit('mtm/choose_fl3_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
            choose_fl4_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_accessory(deep_key, deep_name, option_name, fabric_key)
                this.$store.commit('mtm/choose_fl4_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
        },
        mounted() {
            MAccessoryColor({id: this.category.id}).then(response => {
                this.accessory_color_map = response.data
                console.log(111, response.data)
            })
            this.cal_part = this.part
            for (let j in this.part) {
                let o1 = this.part[j].option_list
                for (let k in o1) {
                    let o2 = this.part[j].option_list[k]
                    if (!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for (let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.category_key] = o3.option_list
                    }
                    this.relate_map_part.set(o2.part_key, obj)
                }
            }
            this.open_right(this.part[0])
            this.cal_accessory = this.accessory
            for (let j in this.accessory) {
                let o1 = this.accessory[j].option_list
                for (let k in o1) {
                    let o2 = this.accessory[j].option_list[k]
                    if (!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for (let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.deep_key] = o3.option_list
                    }
                    this.relate_map_accessory.set(o2.text, obj)
                }
            }
            this.cal_flower = this.flower
            for (let j in this.flower) {
                let o1 = this.flower[j].option_list
                for (let k in o1) {
                    let o2 = this.flower[j].option_list[k]
                    if (!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for (let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.deep_key] = o3.option_list
                    }
                    this.relate_map_flower.set(o2.text, obj)
                }
            }

            // 第一次进页面
            if (Object.keys(this.part_list).length === 0) {
                for (let index_outer in this.part) {
                    let part_item = this.part[index_outer]
                    let first_option = part_item.option_list[0]
                    if (first_option) {
                        this.choose_part(part_item.category_key, part_item.category_name_cn, first_option.part_name_cn, first_option.part_key, first_option.model_path, part_item.no_cad)
                    }
                }
            }
            // if (Object.keys(this.accessory_list).length === 0) {
            //     for (let index_outer in this.accessory) {
            //         let deep_item = this.accessory[index_outer]
            //         if (deep_item.option_list.length > 0) {
            //             let first_option = deep_item.option_list[0]
            //             this.choose_accessory(deep_item.deep_key, deep_item.deep_name, first_option.text, first_option.key)
            //         }
            //
            //     }
            // }
            if (Object.keys(this.flower_list).length === 0) {
                for (let index_outer in this.flower) {
                    let deep_item = this.flower[index_outer]
                    if (deep_item.option_list.length > 0) {
                        let first_option = deep_item.option_list[0]
                        this.choose_flower(deep_item.deep_key, deep_item.deep_name, first_option.text, first_option.key, first_option.sku)
                    }

                }
            }

            for (let j in this.accessory) {
                this.$set(this.filter_accessory, this.accessory[j].deep_key, 0)
                // console.log(this.accessory[j])
            }

            this.interval_id = setInterval(() => {
                // return
                let deep_key_arr = this.accessory.map(v => v.deep_key)
                for (let index in deep_key_arr) {
                    let key_self = deep_key_arr[index]
                    let options_arr = Array.of();
                    let flag = false


                    // 寻找其他部位选中项可能对当前的影响
                    for (let key_another in this.part_list) {

                        let part_another = this.part.find(v => v.category_key === key_another)

                        let relate_another = part_another.option_list.find(v => v.part_name_cn == this.part_list[key_another])
                        // 寻找其他部位选中项是否有relate_part对当前的影响
                        let ldd = {option_list: (relate_another && this.relate_map_part.has(relate_another.part_key) && this.relate_map_part.get(relate_another.part_key)[key_self] ? this.relate_map_part.get(relate_another.part_key)[key_self] : [])}
                        if (ldd.option_list.length === 0) {
                            continue;
                        }

                        let sb = Array.from(new Set(ldd.option_list));
                        // 这里是合集，不是交集
                        options_arr = [...options_arr, ...sb]
                        options_arr = Array.from(new Set(options_arr.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                        flag = true
                    }
                    options_arr = options_arr.map(v => {
                        return {
                            text: v.part_name_cn,
                            image: v.image,
                            key: v.part_key
                        }
                    })
                    // console.log(777, key_self, options_arr)

                    for (let key_another in this.accessory_list) {
                        let part_another = this.accessory.find(v => v.deep_key === key_another)
                        let relate_another = part_another.option_list.find(v => v.text == this.accessory_list[key_another])
                        // 寻找其他部位选中项是否有relate_part对当前的影响
                        let ldd = {option_list: (relate_another && this.relate_map_accessory.has(relate_another.key) && this.relate_map_accessory.get(relate_another.key)[key_self] ? this.relate_map_accessory.get(relate_another.key)[key_self] : [])}
                        if (ldd.option_list.length === 0) {
                            continue;
                        }

                        let sa = Array.from(new Set(options_arr.map(v => v.text)));
                        let sb = Array.from(new Set(ldd.option_list.map(v => v.text)));
                        let intersect_keys = sa.filter(x => sb.includes(x));
                        options_arr = options_arr.filter(v => intersect_keys.includes(v.text))
                        options_arr = [...new Map(options_arr.map(v => [v.text, v])).values()]

                    }

                    if (flag === false) {
                        continue;
                    }


                    let filter_option_list = options_arr

                    if ((this.accessory.map(v => v.deep_key)).includes(key_self)) {
                        let idx = this.accessory.findIndex((v) => {
                            return v.deep_key === key_self
                        })

                        // 填充计算后选项
                        this.$store.commit('mtm/update_category_option', {
                            key: 'accessory',
                            index: idx,
                            option_list: filter_option_list
                        })

                        if (!((filter_option_list.map(v => v.text)).includes(this.accessory_list[key_self])) && this.accessory_list[key_self] !== undefined) {
                            this.$store.commit('mtm/clear_accessory', {
                                deep_key: key_self
                            })
                        }


                    }
                }

            }, 500 * 3)

        },
        destroyed() {
            clearInterval(this.interval_id)
        },
    }
</script>

<style lang="scss" scoped>
    // chrome,safari浏览器滚动条适配
    ::-webkit-scrollbar {
        width: 10px;
        height: 3px;
    }

    ::-webkit-scrollbar-track {
        background: #eee;
        border-radius: 2px;
    }

    ::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #ddd
    }

    ::-webkit-scrollbar-corner {
        background: #ddd;
    }

    .section-wrap {
        .left {
            position: absolute;
            top: 0;
            left: 0;
            width: 270px;
            height: 99.5%;
            overflow-y: scroll;

            .collapse-title {
                width: 100%;
                height: 44px;
                line-height: 44px;
                background: #FAFAFA;
                text-align: left;
                font-size: 14px;
                color: #0F114A;
                padding: 0 20px;
                font-weight: bold;
                user-select: none;
            }

            .collapse-content {
                .list {
                    padding: 0 20px;

                    .item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #000;
                        height: 44px;

                        .name {
                            font-size: 14px;

                            .red {
                                color: red;
                            }
                        }

                        .value {
                            font-size: 12px;
                            max-width: 70%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }

                }
            }
        }

        .right {
            position: absolute;
            top: 5px;
            right: 0;
            width: 1080px;
            height: 98%;
            overflow-y: scroll;

            .cate-box {
                margin: 20px 10px;
                display: flex;
                flex-wrap: wrap;

                .radio-wrap {
                    width: 100%;
                    height: 30px;
                }
                .cate {
                    position: relative;
                    width: 200px;
                    margin: 10px 5px;
                    font-size: 15px;
                    font-weight: 400;
                    color: #666666;
                    text-align: center;
                    border-radius: 2px;
                    cursor: pointer;

                    .img {
                        width: 200px;
                        height: 200px;
                        padding: 25px;
                        border: 1px solid #DDDDDD;
                        box-sizing: border-box;
                    }

                    .magnifier {
                        position: absolute;
                        top: 150px;
                        right: 10px;
                        width: 40px;
                        height: 40px;
                        z-index: 10;
                    }

                    .name {
                        margin-top: 10px;
                    }

                    &.cate-active {
                        .img {
                            border: 1px solid #0f114a;
                        }

                        .name {
                            font-weight: bold;
                            color: #0F114A;
                        }
                    }
                }


                .color-list {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .color-item {
                        width: 80px;
                        text-align: center;
                        margin:10px 10px 0 0;
                        cursor: pointer;
                        .item-wrap{
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            .color-image {
                                width: 80px;
                                height: 80px;
                                border: 0;
                                margin: 0;
                            }
                            .color-radio {
                                position: absolute;
                                top: 5px;
                                right: 5px;
                                width: 13px;
                                height: 13px;
                            }
                        }
                        .color-name {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }

    .select-active {
        position: relative;
    }

    .select-active:after {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/images/design/select@2x.png");
        background-size: 100%;

        content: "";
    }
</style>
